module.exports = __webpack_public_path__ + "media/src/images/icon__magazinFalsch3--dark-350806446a2878ea9dbcffa6ef56aa07.svg";